import React from 'react';
import Layout from '../../../components/Layout';
import Hero, { useHeroVariant } from '../../../components/Hero';
import Reveal, { SplitWords } from '../../../components/Reveal';

/**
 * @author Nelson
 */
const Home = () => {
    const variant = useHeroVariant();

    return (
        <Layout title="Home">
            <Hero variant={variant}>
                <h1 className="page__eyebrow reveal" style={{ '--reveal-delay': '120ms' }}>
                    YUAN Lab Enterprise
                </h1>
                <h2 className="page__title page__title--display">
                    <SplitWords text="Welcome to YUAN Lab Enterprise" start={260} />
                </h2>
            </Hero>

            <div className="prose">
                <Reveal as="p" delay={620}>
                    At YUAN Lab Enterprise, we create mobile apps that entertain, engage, and make everyday moments better.
                    From lighthearted party games to practical utilities and creative tools, our goal is to bring useful and enjoyable digital experiences to life.
                </Reveal>
                <Reveal as="p" delay={700}>
                    Our diverse app lineup spans different categories, but they all share one thing: a commitment to simplicity, creativity, and user delight.
                    Whether you're looking for a laugh, a tool, or a unique interaction, there's something from YUAN Lab for you.
                </Reveal>
                <Reveal as="p" delay={780}>
                    Explore our products, get to know our team, or reach out through our support page — we’re always building something new.
                </Reveal>
            </div>
        </Layout>
    );
};

export default Home;
